var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UnderlinedHeading',{staticClass:"ph3 ph4-ns bg-near-white",attrs:{"route":_vm.showLink ? _vm.route : null,"linkText":_vm.showLink ? _vm.linkText : null}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }